import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Resize Unsplash images to the size they are displayed at, served as WebP/AVIF.
export const sizedImg = (u, w) => (u && u.includes("images.unsplash.com") ? `${u.split("?")[0]}?auto=format&fit=crop&w=${w}&q=70` : u);
